import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth.jsx";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      toast.error("Missing Google session — please try again.");
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { access } = await loginWithGoogleSession(sessionId);
        // clean URL hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google");
        nav(access?.is_active ? "/dashboard" : "/paywall", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [loginWithGoogleSession, nav]);

  return (
    <div className="min-h-screen bg-brimi-cream flex items-center justify-center px-5">
      <div className="brimi-card p-8 text-center max-w-sm">
        <div className="w-10 h-10 rounded-full border-2 border-brimi-navy/25 border-t-brimi-navy animate-spin mx-auto" />
        <p className="mt-4 text-brimi-navyText font-heading font-semibold">Signing you in…</p>
        <p className="text-sm text-brimi-navyText/65 mt-1">One second — finishing Google sign-in.</p>
      </div>
    </div>
  );
}
